

























































































































































































import { walletStore } from '@/stores/wallet-store'
import { Observer } from 'mobx-vue'
import { Component, Inject, Vue } from 'vue-property-decorator'
import { FarmingViewModel } from '../viewmodels/farming-viewmodel'

@Observer
@Component({
  components: {
    'select-lock-period': () => import('@/modules/sb-farm/components/select-lock-period.vue'),
    'multi-logo': () => import('@/components/multi-logo/multi-logo.vue'),
    ConnectButton: () => import('@/components/ConnectButton.vue')
  }
})
export default class StakePairCalculator extends Vue {
  @Inject() vm!: FarmingViewModel
  walletStore = walletStore

  viewLP() {
    if (this.vm.farmType === 'SB')
      window.open(`https://bscscan.com/address/0xF87229e02C8d1dB73772702D92F47384F1920eaA`, '_blank')
    else window.open(`https://bscscan.com/address/0xF87229e02C8d1dB73772702D92F47384F1920eaA`, '_blank')
  }
}
